module.exports = __webpack_public_path__ + "bz.png?ac60d612cc3bb19317d62e82c031d01d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bz.png
// module id = 103
// module chunks = 0